
        
    const runtime = require("../../../../../../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
    __nunjucks_module_dependencies__.templates = {};
    __nunjucks_module_dependencies__.globals = {};
    __nunjucks_module_dependencies__.extensions = {};
    __nunjucks_module_dependencies__.filters = {};
    __nunjucks_module_dependencies__.assets = {};
    
    
    
    
    
    
        
            __nunjucks_module_dependencies__.templates["assessments/admin/views/templates/new-question.html"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"pw-uniform-table no-border\">\n  <div data-row-span=\"1\">\n    <div data-field-span=\"1\" class=\"focus\">\n      <label>Add a new question:</label>\n      <select class=\"form-control\">\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "typeChoices");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("choice", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        <option\n          value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"val"), env.opts.autoescape);
output += "\"\n          ";
if(runtime.memberLookup((t_4),"selected")) {
output += "\n          selected";
;
}
output += "\n        >\n          ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "\n        </option>\n        ";
;
}
}
frame = frame.pop();
output += "\n      </select>\n      <button\n        class=\"add-new-question-button ButtonLegacy medium rounded primary interactive\"\n      >\n        Add\n      </button>\n    </div>\n  </div>\n</div>\n<div class=\"question-disable-overlay\"></div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":false,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "assessments/admin/views/templates/new-question.html",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "assessments/admin/views/templates/new-question.html",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["assessments/admin/views/templates/new-question.html"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    